import { Box, Typography } from "@mui/material";

const NoAdminsFoundMessage = (): React.JSX.Element => (
  <Box
    sx={{
      backgroundColor: "#eeeeee",
      mb: 2,
      p: 2,
      borderRadius: 2,
    }}
  >
    <Typography variant="h6">Keine Admins gefunden</Typography>
  </Box>
);

export default NoAdminsFoundMessage;
